export default __webpack_public_path__ + "1cd3c705e9fbc0931814adc8587bdda6.png";